import { Grid, WithStyles } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import * as React from "react";
import { styles } from "./UserDetailsForm.styles";
import { BlueButton } from "../../Buttons/BlueButton";
import { FormTextField } from "../../FormComponents/FormTextField";
import UserDetailsModel from "../../../../models/user/UserDetailsModel";
import { useTranslation } from "react-i18next";
import { isPermissionGranted } from "../../../../utilities/permissionUtils";
import { useGetRoles } from "../../../../hooks/useGetRole";
import { emailPattern, phonePattern } from "../../../../utilities/generalUtils";

export interface IUserDetailsFormProps extends WithStyles<typeof styles> {
    userDetails: UserDetailsModel
    onSave: any
}

const UserDetailsFormPure: React.FunctionComponent<IUserDetailsFormProps> = ({
                                                                                 onSave,
                                                                                 userDetails,
                                                                                 classes
                                                                             }: IUserDetailsFormProps) => {

    const [details, setDetails] = React.useState({
        email: userDetails.email,
        additionalEmail2: userDetails.additionalEmail2,
        additionalEmail2Verified: userDetails.additionalEmail2Verified,
        additionalEmail3: userDetails.additionalEmail3,
        additionalEmail3Verified: userDetails.additionalEmail3Verified,
        firstName: userDetails.firstName,
        lastName: userDetails.lastName,
        phone: userDetails.phone,
        mobilePhone: userDetails.mobilePhone
    });

    const internalUser = userDetails.username === "";

    const [errors, setErrors] = React.useState([]);

    const handleChange = (event, valid) => {
        const name = event.target.name;
        const value = event.target.value;

        setDetails({
            ...details,
            [name]: value
        });

        if (valid !== undefined) {
            if (valid) {
                setErrors(errors.filter(e => e !== name));
            } else {
                setErrors(errors.concat(name));
            }
        };
    };

    const handleSave = () => {
        if (!errors.length) {
            userDetails.email = details.email;
            userDetails.additionalEmail2 = details.additionalEmail2;
            userDetails.additionalEmail3 = details.additionalEmail3;
            userDetails.firstName = details.firstName;
            userDetails.lastName = details.lastName;
            userDetails.phone = details.phone;
            userDetails.mobilePhone = details.mobilePhone;

            onSave(userDetails);
        }
    };

    const isDisabled = !isPermissionGranted(useGetRoles(), "users.write");
    const {t} = useTranslation();

    const email2HelperText = userDetails.additionalEmail2Verified === true ? "" : "Email must be validated";
    const email3HelperText = userDetails.additionalEmail3Verified === true ? "" : "Email must be validated";

    return <>
        <Grid container spacing={3}>
            <Grid item xs={12} sm={4}>
                <FormTextField id="firstName" required onChange={handleChange} value={details.firstName} label={t("general.firstName")} disabled={isDisabled || internalUser} />
            </Grid>
            <Grid item xs={12} sm={4}>
                <FormTextField id="lastName" required onChange={handleChange} value={details.lastName} label={t("general.lastName")} disabled={isDisabled || internalUser} />
            </Grid>
        </Grid>
        <Grid container spacing={3}>
            <Grid item xs={12} sm={4}>
                <FormTextField id="additionalEmail2" onChange={handleChange} value={details.additionalEmail2} label="Email 2" pattern={emailPattern} helperText={email2HelperText} disabled={isDisabled} />
            </Grid>
            <Grid item xs={12} sm={4}>
                <FormTextField id="additionalEmail3" onChange={handleChange} value={details.additionalEmail3} label="Email 3" pattern={emailPattern} helperText={email3HelperText} disabled={isDisabled} />
            </Grid>
        </Grid>
        <Grid container spacing={3}>
            <Grid item xs={12} sm={4}>
                <FormTextField id="phone"  onChange={handleChange} value={details.phone} label={t("general.phone")} pattern={phonePattern} disabled={isDisabled}/>
            </Grid>
            <Grid item xs={12} sm={4}>
                <FormTextField id="mobilePhone" onChange={handleChange} value={details.mobilePhone} label={t("general.mobilePhone")} pattern={phonePattern} disabled={isDisabled}/>
            </Grid>
        </Grid>
        <BlueButton disabled={isDisabled || errors.length > 0} onClick={handleSave} >{t("general.save")}</BlueButton>
    </>;
};

export const UserDetailsForm = withStyles(styles)(UserDetailsFormPure);
